//================== CONSTANTES =====================
window.localLanguage = currentLanguage.substring(0, 2);

/**
 * Multilang names and descriptions
 */
window.OBJ_TYPES_MULTILNG = {
		"EVENTS" : "events",
		"SESSIONS" : "sessions",
		"PROMOTIONAL_SESSION_LABEL" : "promotional_session_labels",
		"PRODUCTS" : "products",
		"PRODUCTS_DESC" : "products_desc",
		"PRODUCTS_URL_LEGAL_CONDITIONS" : "products_url_legal_conditions",
		"ZONE_GROUPS" : "zone_groups",
		"ZONES" : "zones"
}

window.countries = [];
window.taxName = "";
window.taxDefaultValue = 0;
window.authorsRoyaltiesPercentageDefaultValue = 0;
window.authorsRoyaltiesTaxDefaultValue = 0;
window.showAuthorsRoyalties = false;

window.initializeCountries = function () {
	countries = [];
	if(typeof regions !== 'undefined'){
		for (let i = 0; i < regions.length; i++) {
			countries.push(regions[i].country);
		}
	}
}
initializeCountries();

window.initializeTaxesDefaultValues = function () {
	try {
		const obj = JSON.parse(taxesDefaultValues);
		taxName = (obj.taxName ? obj.taxName : "");
		taxDefaultValue = (obj.taxDefaultValue ? obj.taxDefaultValue : 0);
		authorsRoyaltiesPercentageDefaultValue = (obj.authorsRoyaltiesPercentageDefaultValue ? obj.authorsRoyaltiesPercentageDefaultValue : 0);
		authorsRoyaltiesTaxDefaultValue = (obj.authorsRoyaltiesTaxDefaultValue ? obj.authorsRoyaltiesTaxDefaultValue : 0);
		showAuthorsRoyalties = (obj.showAuthorsRoyalties ? obj.showAuthorsRoyalties : false);
	} catch (e) {
		console.log("EXCEPTION getting taxes default values:", e);
	}
}
initializeTaxesDefaultValues();


// ========================== FORMATEO DE OBJETOS DE FECHA ====================
// ============>>>>> NO USAR - USAR getWeekNumber o getWeekYear en su lugar!
/**
 * Obtiene el numero de semana en el año.
 */
// function getWeekNumber(dateIso)
Date.prototype.getWeekNumber = function () {
	let d = new Date(+this);
	d.setHours(0, 0, 0, 0);
	d.setDate(d.getDate() + 4 - (d.getDay() || 7));
	return Math.ceil((((d - new Date(d.getFullYear(), 0, 1)) / 8.64e7) + 1) / 7);
};


/**
 * Devuelve el año del número de semana.
 */
// function getWeekYear(dateIso)
window.getAnyoSemana = function (anyo, mes, semana) {
	let anyoSemana = anyo;
	if (mes == 1 && semana > 50)
		anyoSemana--;
	else if (mes == 12 && semana == 1)
		anyoSemana++;
	return anyoSemana;
}


// ---- CURRENCIES ----

window.CurrencyFormat = function (codeA, preffix, suffix, decimal, thousand, precision) {
	this.codeA = codeA;
	this.preffix = preffix;
	this.suffix = suffix;
	this.decimal = decimal;
	this.thousand = thousand;
	this.precision = precision;
}


window.currencyFormats = [
	new window.CurrencyFormat("AED", "$", "", ".", ",", 2),
	new window.CurrencyFormat("AFN", "$", "", ".", ",", 2),
	new window.CurrencyFormat("ALL", "$", "", ".", ",", 2),
	new window.CurrencyFormat("AMD", "$", "", ".", ",", 2),
	new window.CurrencyFormat("ANG", "$", "", ".", ",", 2),
	new window.CurrencyFormat("AOA", "Kz", "", ".", ",", 2),
	new window.CurrencyFormat("ARS", "$", "", ".", ",", 2),
	new window.CurrencyFormat("AUD", "A$", "", ".", ",", 2),
	new window.CurrencyFormat("AWG", "$", "", ".", ",", 2),
	new window.CurrencyFormat("AZN", "$", "", ".", ",", 2),
	new window.CurrencyFormat("BAM", "KM", "", ".", ",", 2),
	new window.CurrencyFormat("BBD", "$", "", ".", ",", 2),
	new window.CurrencyFormat("BDT", "$", "", ".", ",", 2),
	new window.CurrencyFormat("BGN", "$", "", ".", ",", 2),
	new window.CurrencyFormat("BHD", "$", "", ".", ",", 2),
	new window.CurrencyFormat("BIF", "$", "", ".", ",", 2),
	new window.CurrencyFormat("BMD", "$", "", ".", ",", 2),
	new window.CurrencyFormat("BND", "$", "", ".", ",", 2),
	new window.CurrencyFormat("BOB", "Bs", "", ".", ",", 2),
	new window.CurrencyFormat("BRL", "R$", "", ".", ",", 2),
	new window.CurrencyFormat("BSD", "$", "", ".", ",", 2),
	new window.CurrencyFormat("BTC", "", " BTC", ".", ",", 8),
	new window.CurrencyFormat("BTN", "$", "", ".", ",", 2),
	new window.CurrencyFormat("BWP", "$", "", ".", ",", 2),
	new window.CurrencyFormat("BZD", "$", "", ".", ",", 2),
	new window.CurrencyFormat("CAD", "C$", "", ".", ",", 2),
	new window.CurrencyFormat("CDF", "$", "", ".", ",", 2),
	new window.CurrencyFormat("CHF", "CHF ", "", ",", ".", 2),
	new window.CurrencyFormat("CLF", "$", "", ".", ",", 2),
	new window.CurrencyFormat("CLP", "$", "", ",", ".", 0),
	new window.CurrencyFormat("CNY", "¥", "", ".", ",", 2),
	new window.CurrencyFormat("COP", "$", "", ".", ",", 2),
	new window.CurrencyFormat("CRC", "", " CRC", ".", ",", 2),
	new window.CurrencyFormat("CUC", "$", "", ".", ",", 2),
	new window.CurrencyFormat("CUP", "$", "", ".", ",", 2),
	new window.CurrencyFormat("CVE", "$", "", ".", ",", 2),
	new window.CurrencyFormat("CZK", "$", "", ".", ",", 2),
	new window.CurrencyFormat("DJF", "$", "", ".", ",", 2),
	new window.CurrencyFormat("DKK", "$", "", ".", ",", 2),
	new window.CurrencyFormat("DOP", "", " RD$", ".", ",", 2),
	new window.CurrencyFormat("DZD", "$", "", ".", ",", 2),
	new window.CurrencyFormat("EGP", "E£", "", ".", ",", 2),
	new window.CurrencyFormat("ERN", "$", "", ".", ",", 2),
	new window.CurrencyFormat("ETB", "$", "", ".", ",", 2),
	new window.CurrencyFormat("ETH", "$", "", ".", ",", 2),
	new window.CurrencyFormat("EUR", "", " €", ",", ".", 2),
	new window.CurrencyFormat("FJD", "$", "", ".", ",", 2),
	new window.CurrencyFormat("FKP", "$", "", ".", ",", 2),
	new window.CurrencyFormat("GBP", "£", "", ".", ",", 2),
	new window.CurrencyFormat("GEL", "$", "", ".", ",", 2),
	new window.CurrencyFormat("GHS", "$", "", ".", ",", 2),
	new window.CurrencyFormat("GIP", "$", "", ".", ",", 2),
	new window.CurrencyFormat("GMD", "$", "", ".", ",", 2),
	new window.CurrencyFormat("GNF", "$", "", ".", ",", 2),
	new window.CurrencyFormat("GTQ", "$", "", ".", ",", 2),
	new window.CurrencyFormat("GYD", "$", "", ".", ",", 2),
	new window.CurrencyFormat("HKD", "HK$", "", ".", ",", 2),
	new window.CurrencyFormat("HNL", "", " L", ".", ",", 2),
	new window.CurrencyFormat("HRK", "$", "", ".", ",", 2),
	new window.CurrencyFormat("HTG", "$", "", ".", ",", 2),
	new window.CurrencyFormat("HUF", "$", "", ".", ",", 2),
	new window.CurrencyFormat("IDR", "Rp ", "", ",", ".", 0),
	new window.CurrencyFormat("ILS", "₪", "", ".", ",", 2),
	new window.CurrencyFormat("INR", "$", "", ".", ",", 2),
	new window.CurrencyFormat("IQD", "$", "", ".", ",", 2),
	new window.CurrencyFormat("IRR", "$", "", ".", ",", 2),
	new window.CurrencyFormat("ISK", "$", "", ".", ",", 2),
	new window.CurrencyFormat("JMD", "$", "", ".", ",", 2),
	new window.CurrencyFormat("JOD", "$", "", ".", ",", 2),
	new window.CurrencyFormat("JPY", "", "円", ".", ",", 0),
	new window.CurrencyFormat("KES", "$", "", ".", ",", 2),
	new window.CurrencyFormat("KGS", "$", "", ".", ",", 2),
	new window.CurrencyFormat("KHR", "$", "", ".", ",", 2),
	new window.CurrencyFormat("KMF", "$", "", ".", ",", 2),
	new window.CurrencyFormat("KPW", "$", "", ".", ",", 2),
	new window.CurrencyFormat("KRW", "$", "", ".", ",", 2),
	new window.CurrencyFormat("KWD", "$", "", ".", ",", 2),
	new window.CurrencyFormat("KYD", "$", "", ".", ",", 2),
	new window.CurrencyFormat("KZT", "$", "", ".", ",", 2),
	new window.CurrencyFormat("LAK", "$", "", ".", ",", 2),
	new window.CurrencyFormat("LBP", "$", "", ".", ",", 2),
	new window.CurrencyFormat("LKR", "$", "", ".", ",", 2),
	new window.CurrencyFormat("LRD", "$", "", ".", ",", 2),
	new window.CurrencyFormat("LSL", "$", "", ".", ",", 2),
	new window.CurrencyFormat("LTC", "$", "", ".", ",", 2),
	new window.CurrencyFormat("LYD", "$", "", ".", ",", 2),
	new window.CurrencyFormat("MAD", "$", "", ".", ",", 2),
	new window.CurrencyFormat("MDL", "$", "", ".", ",", 2),
	new window.CurrencyFormat("MGA", "$", "", ".", ",", 2),
	new window.CurrencyFormat("MKD", "$", "", ".", ",", 2),
	new window.CurrencyFormat("MMK", "$", "", ".", ",", 2),
	new window.CurrencyFormat("MNT", "$", "", ".", ",", 2),
	new window.CurrencyFormat("MOP", "$", "", ".", ",", 2),
	new window.CurrencyFormat("MRO", "$", "", ".", ",", 2),
	new window.CurrencyFormat("MUR", "$", "", ".", ",", 2),
	new window.CurrencyFormat("MVR", "$", "", ".", ",", 2),
	new window.CurrencyFormat("MWK", "$", "", ".", ",", 2),
	new window.CurrencyFormat("MXN", "$", "", ".", ",", 2),
	new window.CurrencyFormat("MYR", "$", "", ".", ",", 2),
	new window.CurrencyFormat("MZN", "$", "", ".", ",", 2),
	new window.CurrencyFormat("NAD", "$", "", ".", ",", 2),
	new window.CurrencyFormat("NGN", "$", "", ".", ",", 2),
	new window.CurrencyFormat("NIO", "$", "", ".", ",", 2),
	new window.CurrencyFormat("NOK", "$", "", ".", ",", 2),
	new window.CurrencyFormat("NPR", "$", "", ".", ",", 2),
	new window.CurrencyFormat("NZD", "$", "", ".", ",", 2),
	new window.CurrencyFormat("OMR", "$", "", ".", ",", 2),
	new window.CurrencyFormat("PAB", "$", "", ".", ",", 2),
	new window.CurrencyFormat("PEN", "S/", "", ".", ",", 2),
	new window.CurrencyFormat("PGK", "$", "", ".", ",", 2),
	new window.CurrencyFormat("PHP", "$", "", ".", ",", 2),
	new window.CurrencyFormat("PKR", "$", "", ".", ",", 2),
	new window.CurrencyFormat("PYG", "$", "", ".", ",", 2),
	new window.CurrencyFormat("QAR", "$", "", ".", ",", 2),
	new window.CurrencyFormat("RON", "$", "", ".", ",", 2),
	new window.CurrencyFormat("RSD", "$", "", ".", ",", 2),
	new window.CurrencyFormat("RUB", "$", "", ".", ",", 2),
	new window.CurrencyFormat("RWF", "$", "", ".", ",", 2),
	new window.CurrencyFormat("SAR", "$", "", ".", ",", 2),
	new window.CurrencyFormat("SBD", "$", "", ".", ",", 2),
	new window.CurrencyFormat("SCR", "$", "", ".", ",", 2),
	new window.CurrencyFormat("SDG", "$", "", ".", ",", 2),
	new window.CurrencyFormat("SEK", "", " Kr", ",", ".", 0),
	new window.CurrencyFormat("SGD", "$", "", ".", ",", 2),
	new window.CurrencyFormat("SHP", "$", "", ".", ",", 2),
	new window.CurrencyFormat("SLL", "$", "", ".", ",", 2),
	new window.CurrencyFormat("SOS", "$", "", ".", ",", 2),
	new window.CurrencyFormat("SRD", "$", "", ".", ",", 2),
	new window.CurrencyFormat("SSP", "$", "", ".", ",", 2),
	new window.CurrencyFormat("STD", "$", "", ".", ",", 2),
	new window.CurrencyFormat("SVC", "$", "", ".", ",", 2),
	new window.CurrencyFormat("SYP", "$", "", ".", ",", 2),
	new window.CurrencyFormat("SZL", "$", "", ".", ",", 2),
	new window.CurrencyFormat("THB", "$", "", ".", ",", 2),
	new window.CurrencyFormat("TJS", "$", "", ".", ",", 2),
	new window.CurrencyFormat("TMT", "$", "", ".", ",", 2),
	new window.CurrencyFormat("TND", "$", "", ".", ",", 2),
	new window.CurrencyFormat("TOP", "$", "", ".", ",", 2),
	new window.CurrencyFormat("TRY", "$", "", ".", ",", 2),
	new window.CurrencyFormat("TTD", "$", "", ".", ",", 2),
	new window.CurrencyFormat("TWD", "$", "", ".", ",", 2),
	new window.CurrencyFormat("TZS", "$", "", ".", ",", 2),
	new window.CurrencyFormat("UAH", "$", "", ".", ",", 2),
	new window.CurrencyFormat("UGX", "$", "", ".", ",", 2),
	new window.CurrencyFormat("USD", "$", "", ".", ",", 2),
	new window.CurrencyFormat("UYU", "$", "", ".", ",", 2),
	new window.CurrencyFormat("UZS", "$", "", ".", ",", 2),
	new window.CurrencyFormat("VEF", "Bs. ", "", ".", ",", 2),
	new window.CurrencyFormat("VND", "$", "", ".", ",", 2),
	new window.CurrencyFormat("VUV", "$", "", ".", ",", 2),
	new window.CurrencyFormat("WST", "$", "", ".", ",", 2),
	new window.CurrencyFormat("XAF", "$", "", ".", ",", 2),
	new window.CurrencyFormat("XCD", "$", "", ".", ",", 2),
	new window.CurrencyFormat("XDR", "$", "", ".", ",", 2),
	new window.CurrencyFormat("XMR", "$", "", ".", ",", 2),
	new window.CurrencyFormat("XOF", "$", "", ".", ",", 2),
	new window.CurrencyFormat("XPF", "$", "", ".", ",", 2),
	new window.CurrencyFormat("XRP", "$", "", ".", ",", 2),
	new window.CurrencyFormat("YER", "$", "", ".", ",", 2),
	new window.CurrencyFormat("ZAR", "$", "", ".", ",", 2),
	new window.CurrencyFormat("ZMW", "$", "", ".", ",", 2),
	new window.CurrencyFormat("ZWL", "$", "", ".", ",", 2)
];

window.baseCurrencyFormat = new CurrencyFormat("USD", "$", "", ".", ",", 2);

window.getCurrencyCode = function () {
	if (window.baseCurrencyFormat) return baseCurrencyFormat.codeA;
	return "USD";
}

window.getCurrencyFormat = function (code) {
	if (typeof currencyRates != "undefined") {
		for (let i in currencyRates) {
			if (currencyRates[i].codeA == code)
				return currencyRates[i];
		}
	}

	for (let i in currencyFormats) {
		if (currencyFormats[i].codeA == code)
			return currencyFormats[i];
	}
	return window.baseCurrencyFormat;
}

if (baseCurrency)
	baseCurrencyFormat = getCurrencyFormat(baseCurrency);

window.formatCurrency = function (value, currencyCode) {
	let currencyFormat = baseCurrencyFormat;

	if (currencyCode != null && currencyCode != currencyFormat.codeA)
		currencyFormat = getCurrencyFormat(currencyCode);

	return currencyFormat.preffix + window.formatCurrencyNumber(value, currencyCode, currencyFormat) + currencyFormat.suffix;
}

window.formatCurrencyNumber = function (value, currencyCode, currencyFormatOpt) {
	let currencyFormat = currencyFormatOpt;
	if (currencyFormat == null) {
		if (finalCurrency != null) {
			currencyFormat = getCurrencyFormat(finalCurrency);
		}
		else {
			currencyFormat = baseCurrencyFormat;
		}
	}


	if (currencyCode != null && currencyCode != currencyFormat.codeA)
		currencyFormat = getCurrencyFormat(currencyCode);

	const negative = value < 0;
	const mnt = parseFloat(value).toFixed(currencyFormat.precision).toString();

	let decimalPart = "";
	let integerPart = mnt;

	if (currencyFormat.precision > 0) {
		const p = mnt.indexOf(".");
		integerPart = mnt.substring(0, p);
		decimalPart = mnt.substring(p + 1);

		integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, currencyFormat.thousand);

		return (negative && !integerPart.startsWith("-") ? "-" : "") + integerPart + currencyFormat.decimal + decimalPart;
	}
	integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, currencyFormat.thousand);
	return (negative && !integerPart.startsWith("-") ? "-" : "") + integerPart;
}


window.parseCurrency = function (value, currencyCode) {
	// Fails silently
	value = value || 0;

	// Return the value as-is if it's already a number:
	if (typeof value === "number") return value;

	let currencyFormat = baseCurrencyFormat;

	if (currencyCode != null && currencyCode != currencyFormat.codeA)
		currencyFormat = getCurrencyFormat(currencyCode);

	// Build regex to strip out everything except digits, decimal point and minus sign:
	const regex = new RegExp("[^0-9-" + currencyFormat.decimal + "]", ["g"]);

	return parseFloat(
		("" + value)
			.replace(/\((?=\d+)(.*)\)/, "-$1") // replace bracketed values with negatives
			.replace(regex, '')		 // strip out any cruft
			.replace(currencyFormat.decimal, '.')      // make sure decimal point is standard
	);
};


window.currencyFactor = 1;
window.finalCurrency = baseCurrency;

window.changeCurrency = function (currency) {
	finalCurrency = currency;
	localStorage.currency = finalCurrency;

	let baseCurrencyFactor = 1;
	let finalCurrencyFactor = 1;

	let c;
	for (let i in currencyRates) {
		c = currencyRates[i];
		if (c.codeA == baseCurrency)
			baseCurrencyFactor = c.rate;
		if (c.codeA == finalCurrency)
			finalCurrencyFactor = c.rate;
	}

	currencyFactor = finalCurrencyFactor * (1 + (currencyExchangeSupplement / 100)) / baseCurrencyFactor;

	$(".p4money").each(function (index) { $(this).html(window.getCurrencyFormatted(parseFloat($(this).data("amount")))) });
}

window.getCompanyCurrencyFormatted = function (idCompany, amount) {
	let currency = baseCurrency;

	if (companyCurrencies != null) {
		let companyCurrency;
		for (let i in companyCurrencies) {
			companyCurrency = companyCurrencies[i];
			if (companyCurrency.id == idCompany) {
				currency = companyCurrency.valor;
				break;
			}
		}
	}

	return formatCurrency(amount, currency);
}

window.getCurrencyFormatted = function (amount, currency) {
	if (currency != null)
		return formatCurrency(amount, currency);
	else if (finalCurrency == baseCurrency)
		return formatCurrency(amount, finalCurrency);
	return formatCurrency(amount * currencyFactor, finalCurrency);
}


window.getHtmlFormattedCurrency = function (amount, currency) {
	return "<span class=\"p4money\" data-amount=\"" + amount + "\" >" + window.getCurrencyFormatted(amount, currency) + "</span>";
}

window.getDecimalSeparator = function () {
	return baseCurrencyFormat.decimal;
}

window.getDecimalPrecision = function () {
	return baseCurrencyFormat.precision;
}


// ================ CONSTANT STRINGS AND ARRAY WITH dayjs LIB
// ====================
/**
 * Get an array with long month literals ["January", "February", "March",
 * "April", "May", "June", "July", "August", "September", "October", "November",
 * "December"]
 */
window.getMonthsLongLiteralArray = function () {
	return dayjs.months();
}

/**
 * Get an array with short month literals ["Jan", "Feb", "Mar", "Apr", "May",
 * "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
 */
window.getMonthsShortLiteralArray = function () {
	return dayjs.monthsShort();
}

window.getMonthLiteral = function (monthNumber) {
	if (monthNumber < 1 || monthNumber > 12) return "";
	return dayjs.months()[monthNumber - 1];

}


/**
 * Get an array with long weekday literals ["Sunday", "Monday", "Tuesday",
 * "Wednesday", "Thursday", "Friday", "Saturday"]
 */
window.getWeekdaysLongLiteralArray = function () {
	return dayjs.weekdays();
}

/**
 * Get an array with short weekday literals ["Sun", "Mon", "Tue", "Wed", "Thu",
 * "Fri", "Sat"]
 */
window.getWeekdaysShortLiteralArray = function () {
	return dayjs.weekdaysShort();
}

/**
 * Get an array with acronyms weekday literals ["Su", "Mo", "Tu", "We", "Th",
 * "Fr", "Sa"]
 */
window.getWeekdaysAcronymsArray = function () {
	return dayjs.weekdaysMin();
}

// ================ FORMAT DATA OBJECTS WITH DAYJS LIB ====================
/**
 * Return ISO format
 */
window.formatIso = function (date) {
	return dayjs(date).format('YYYY-MM-DDTHH:mm:ss.SSS') + "Z";
}

/**
 * Return ISO format
 */
window.formatIsoLocal = function (date) {
	return dayjs(date).format("YYYY-MM-DDTHH:mm:ss.SSS");
}

window.formatIsoDate = function (date) {
	return dayjs(date).format("YYYY-MM-DD");
}

/**
 * Return 12 hour AM/PM format from ISO date string
 */
window.format12hTime = function (dateIso) {

	return dayjs(dateIso).format('h:mm a');
}

/**
 * Return Time
 */
window.formatTime = function (dateIso) {
	return dayjs(dateIso).format('LT');
}

/**
 * Return Time with seconds
 */
window.formatTimeSeconds = function (dateIso) {
	return dayjs(dateIso).format('LTS');
}

/**
 * Return Short Date
 */
window.formatDate = function (dateIso) {
	return dayjs(dateIso).format('L');
}

/**
 * Return Short Date with Time
 */
window.formatDateTime = function (dateIso) {
	return dayjs(dateIso).format('L LT');
}

/**
 * Return short date with time that hours have two digits 
 */
window.formatDateTimeWithTwoHoursDig = function (dateIso) {
	return dayjs(dateIso).format('L HH:mm');
}

/**
 * Return Long Date
 */
window.formatLongDate = function (dateIso) {
	return dayjs(dateIso).format('LL');
}

/**
 * Return Long Date with Time
 */
window.formatLongDateTime = function (dateIso) {
	return dayjs(dateIso).format('LLL');
}

/**
 * Return Long Date with Time and Day
 */
window.formatLongDateTimeWithDay = function (dateIso) {
	return dayjs(dateIso).format('LLLL');
}

/**
 * Return Long Weekday with Short Date
 */
window.formatLongWeekdayShortDate = function (dateIso) {
	return window.getWeekDayLongLiteral(dateIso) + " " + dayjs(dateIso).format('L');
}

/**
 * Get the Year
 */
window.getYear = function (dateIso) {
	return parseInt(dayjs(dateIso).format('YY'));
}

/**
 * Get the Full Year
 */
window.getFullYear = function (dateIso) {
	return parseInt(dayjs(dateIso).format('YYYY'));
}

/**
 * Get the number of month (1 2 ... 11 12)
 */
window.getMonth = function (dateIso) {
	return parseInt(dayjs(dateIso).format('M'));
}

/**
 * Get the short literal of month (Jan Feb ... Nov Dec)
 */
window.getMonthShortLiteral = function (dateIso) {
	return dayjs(dateIso).format('MMM');
}

/**
 * Get the long literal of month (January February ... November December)
 */
window.getMonthLongLiteral = function (dateIso) {
	return dayjs(dateIso).format('MMMM');
}

/**
 * Get the day of month (1 2 ... 30 31)
 */
window.getMonthDay = function (dateIso) {
	return parseInt(dayjs(dateIso).format('D'));
}

/**
 * Get the acronym of day of week (Su Mo ... Fr Sa)
 */
window.getWeekDayAcronym = function (dateIso) {
	return dayjs(dateIso).format('dd');
}

/**
 * Get the short literal of day of week (Sun Mon ... Fri Sat)
 */
window.getWeekDayShortLiteral = function (dateIso) {
	return dayjs(dateIso).format('ddd');
}

/**
 * Get the long literal of day of week (Sunday Monday ... Friday Saturday)
 */
window.getWeekDayLongLiteral = function (dateIso) {
	return dayjs(dateIso).format('dddd');
}

/**
 * Get the local week number
 */
window.getWeekYear = function (dateIso) {
	return dayjs(dateIso).weekYear();
}

/**
 * Get the local week number
 */
window.getWeekNumber = function (dateIso) {
	return dayjs(dateIso).week();
}


/**
 * Return dayjs object for ISO date string
 */
window.parseIsoDateTime = function (date) {
	return dayjs(date);
}

window.convertIsoDateTimeToCurrentZone = function (date, zone) {
	const currentZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
	return dayjs.tz(date, zone).tz(currentZone);
}

/**
 * Return dayjs object for Time
 */
window.parseTime = function (date) {
	return dayjs(date, 'LT');
}

/**
 * Return dayjs object for Time with seconds
 */
window.parseTimeSeconds = function (date) {
	return dayjs(date, 'LTS');
}

/**
 * Return dayjs object for Short Date
 */
window.parseDate = function (date) {
	return dayjs(date, 'L');
}

/**
 * Return dayjs object for Short Date with Time
 */
window.parseDateTime = function (dateStr) {
	if (dateStr.length <= 10) {
	    dateStr += ' 00:00';
	} 
	let formats = dayjs.Ls[dayjs.locale()].formats ? dayjs.Ls[dayjs.locale()].formats : dayjs.en.formats;
	return dayjs(dateStr, formats['L'] + ' ' + formats['LT']);
}

/**
 * Return dayjs object for Long Date
 */
window.parseLongDate = function (date) {
	return dayjs(date, 'LL');
}

/**
 * Return dayjs object for Long Date with Time
 */
window.parseLongDateTime = function (date) {
	return dayjs(date, 'LLL');
}

window.addMinutesToDate = function (date, minutesToAdd) {
	return dayjs(date).add(dayjs.duration({ 'minutes': minutesToAdd }));
}


/**
 * Compare two dayjs dates.
 * @param date1
 * @param date2
 * @param granularityUnit (if other unit than milliseconds)
 * @returns {Number} 1 if first date is after second date, 0 if they are the same, -1 if first date is before second date
 */
window.compareMoment = function (date1, date2, granularityUnit) {
	if (date1.isSame(date2, granularityUnit)) {
		return 0;
	}
	if (date1.isAfter(date2, granularityUnit)) {
		return 1;
	}
	return -1;
}

/**
 * Compare two dayjs dates with precision of day.
 * @param date1
 * @param date2
 * @returns {Number} 1 if first date is after second date, 0 if they are the same, -1 if first date is before second date
 */
window.compareDate = function (date1, date2) {
	return window.compareMoment(date1, date2, 'day');
}

/**
 * Compare two dayjs dates with precision of second.
 * @param date1
 * @param date2
 * @returns {Number} 1 if first date is after second date, 0 if they are the same, -1 if first date is before second date
 */
window.compareDateTime = function (date1, date2) {
	return window.compareMoment(date1, date2, 'second');
}


/**
 * Formatea un valor numérico como puntos de fidelización, ocultando los decimales a cero.
 */
window.formatLoyaltyPoints = function (value) {
	let mnt = parseFloat(value);
	mnt = Math.round(mnt * 100).toString();
	while (mnt.length < 3) mnt = "0" + mnt;
	if (mnt.substring(mnt.length - 2) == "00")
		return (mnt.substring(0, mnt.length - 2));
	return (mnt.substring(0, mnt.length - 2) + "." + mnt.substring(mnt.length - 2));
}


/**
 * Pinta un valor numérico como puntos de fidelización. Elimina los decimales si son ,00
 */
window.getLoyaltyPointsFormatted = function (valor) {
	return getLoyaltyPointsLiteral(window.formatLoyaltyPoints(valor));
}


//================== DATATABLE =====================
window.datatableTexts = getDatatableTexts();
window.dataTable_idioma = {
	"sProcessing": datatableTexts.sProcessing,
	"sLengthMenu": datatableTexts.sLengthMenu,
	"sZeroRecords": datatableTexts.sZeroRecords,
	"sEmptyTable": datatableTexts.sEmptyTable,
	"sInfo": datatableTexts.sInfo,
	"sInfoEmpty": datatableTexts.sInfoEmpty,
	"sInfoFiltered": datatableTexts.sInfoFiltered,
	"sInfoPostFix": "",
	"sSearch": "<i class='palco4icon palco4icon-search'></i>",
	"sUrl": "",
	"sInfoThousands": baseCurrencyFormat.thousand,
	"sLoadingRecords": datatableTexts.sLoadingRecords,
	"oPaginate": {
		"sFirst": "<i class='palco4icon palco4icon-undo'></i>",
		"sLast": "<i class='palco4icon palco4icon-redo'></i>",
		"sNext": "<i class='palco4icon palco4icon-chevron-right'></i>",
		"sPrevious": "<i class='palco4icon palco4icon-chevron-left'></i>"
	},
	"oAria": {
		"sSortAscending": datatableTexts.sSortAscending,
		"sSortDescending": datatableTexts.sSortDescending
	}
};


window.DATETIME_PICKER_FORMAT = 'dd/mm/yyyy hh:ii';
window.DATE_PICKER_FORMAT = 'dd/mm/yyyy';
window.DATE_PICKER_LANGUAGE = localLanguage;
window.DATE_PICKER_WEEK_START = 1;
window.DATE_PICKER_TODAY = dayjs().format("DD-MM-YYYY");

window.CURRENCY_CODE = baseCurrencyFormat.codeA;

window.getObjNameMultiLang = function(type, objId)
{
	var response = null;

	if (typeof dataL10n != "undefined" && dataL10n != null)
	{
		var list = dataL10n[type];
		if (list != null)
		{
			response = list[objId];
		}
	}

	return response;
}
